import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=0c251c64&scoped=true&"
import script from "./Query.vue?vue&type=script&lang=js&"
export * from "./Query.vue?vue&type=script&lang=js&"
import style0 from "./Query.vue?vue&type=style&index=0&id=0c251c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c251c64",
  null
  
)

export default component.exports